import { ReactNode } from 'react'

type ListEmptyComponentProps = {
  image?: ReactNode
  title: string
  description?: string
}

export const ListEmptyComponent = ({ image, title, description }: ListEmptyComponentProps) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-grow tw-px-6 tw-py-10 tw-text-center animate-fade-in">
      {image && <div className="animate-float">{image}</div>}

      <p className="tw-mt-4 tw-text-base tw-font-semibold tw-text-[var(--text-primary)]">{title}</p>
      {description && (
        <p className="tw-mt-1 tw-text-sm tw-max-w-[220px] tw-text-[var(--text-tertiary)]">{description}</p>
      )}
    </div>
  )
}
